import { render, staticRenderFns } from "./onlineRegistration.vue?vue&type=template&id=16513622&scoped=true&"
import script from "./onlineRegistration.vue?vue&type=script&lang=js&"
export * from "./onlineRegistration.vue?vue&type=script&lang=js&"
import style0 from "./onlineRegistration.vue?vue&type=style&index=0&id=16513622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16513622",
  null
  
)

export default component.exports